import { BaseEntity } from "../base/base-entity";
import { matchType } from "../base/base-type";

export const SummarizedPaymentStatusList = [
  "NONE",
  "WAITING",
  "CANCELLED",
  "DONE",
  "EXCEEDING_PAYMENT",
  "DEFICIENCY_PAYMENT",
] as const;
export type SummarizedPaymentStatus =
  (typeof SummarizedPaymentStatusList)[number];
export const PaymentStatusList = [
  "requested",
  "paid",
  "partial_refunded",
  "refunded",
  "cancelled",
  "deficient_payment",
  "exceeding_payment",
];
export type PaymentStatus = (typeof PaymentStatusList)[number];
export type TaxRateLiterals = "0" | "0.1" | "0.08";
export const PaymentMethods = ["credit_card", "paypay", "payeasy"] as const;
export type PaymentMethod = (typeof PaymentMethods)[number];
export const PaymentMethodUILabel: { [key in PaymentMethod]: string } = {
  credit_card: "クレジットカード",
  paypay: "PayPay",
  payeasy: "ペイジー",
};

export const MaxPaymentAmount = 9999999;
export const MaxInvoiceItems = 10;

export type PaymentType = {
  paymentId?: string;
  amount: number;
  amountDetail: { [key in TaxRateLiterals]: number };
  taxAmount: number;
  taxAmountDetail: { [key in TaxRateLiterals]: number };
  amountCharged: number;
  amountRefunded: number;
  invoice: InvoiceType;
  status: PaymentStatus;
  acceptedPaymentMethods: PaymentMethod[];
  createdAt?: Date;
};

export type InvoiceType = {
  items: InvoiceItemType[];
};

export type InvoiceItemTypeLiterals =
  | ""
  | "exceeding"
  | "deficiency"
  | "exceeding_adjuster"
  | "deficiency_adjuster";

export function gqlToDomainInvoiceType(
  gqlType:
    | "Default"
    | "Exceeding"
    | "Deficiency"
    | "ExceedingAdjuster"
    | "DeficiencyAdjuster",
): InvoiceItemTypeLiterals {
  return matchType(gqlType, {
    Default: "",
    Exceeding: "exceeding",
    Deficiency: "deficiency",
    ExceedingAdjuster: "exceeding_adjuster",
    DeficiencyAdjuster: "deficiency_adjuster",
  });
}

export type InvoiceItemType = {
  type: InvoiceItemTypeLiterals;
  amount: number;
  taxRate: TaxRateLiterals;
  description: string;
};

export type PayeasyDetailType = {
  invoiceNo: string; // 請求書番号
  billDate: string; // 支払い期限（YYYYMMDD形式）
  skNo: string; // 収納機関番号
  customerNum: string; // お客様番号
  confirmationNum: string; // 確認番号
  isExpiredWithNoPayment: boolean;
};

export class Payment extends BaseEntity {
  readonly paymentId?: string;
  readonly amount: number;
  readonly taxAmount: number;
  readonly amountDetail: { [key in TaxRateLiterals]: number };
  readonly amountCharged: number;
  readonly amountRefunded: number;
  readonly taxAmountDetail: { [key in TaxRateLiterals]: number };
  readonly invoice: InvoiceType;
  readonly status: PaymentStatus;
  readonly createdAt?: Date;
  readonly acceptedPaymentMethods: PaymentMethod[];

  constructor(values: PaymentType) {
    super();
    this.paymentId = values.paymentId;
    this.amount = values.amount;
    this.amountDetail = values.amountDetail;
    this.taxAmount = values.taxAmount;
    this.amountCharged = values.amountCharged;
    this.amountRefunded = values.amountRefunded;
    this.taxAmountDetail = values.taxAmountDetail;
    this.invoice = values.invoice;
    this.status = values.status;
    this.createdAt = values.createdAt;
    this.acceptedPaymentMethods = values.acceptedPaymentMethods;
  }
}
